module.exports = __webpack_public_path__ + "static/media/Att-1.60dc2f6b.png";